export const WIDGET_EVENTS = {
  DESTROY: "destroy-widget",
  INITIALIZE_BP: "bp-initialize-borrower-platform",
  READY: "widget-ready",
  REDIRECT: "redirect",
} as const;
